import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    closeTemplateLibrary,
    selectCategory,
    searchTemplates,
    clearSearch,
    setViewMode,
    loadTemplates,
    loadCategories,
    applyTemplateToDocument
} from '../../redux/actions/templateActions';
import { getFilteredTemplates } from '../../redux/reducers/templateReducer';
import '../styles/templates.css';

const TemplateLibrary = ({
    isOpen,
    categories,
    templates,
    selectedCategory,
    searchQuery,
    viewMode,
    closeTemplateLibrary,
    selectCategory,
    searchTemplates,
    clearSearch,
    setViewMode,
    loadTemplates,
    loadCategories,
    applyTemplateToDocument
}) => {
    useEffect(() => {
        // Component mount olduğunda verileri yükle
        loadCategories();
        loadTemplates();
    }, [loadCategories, loadTemplates]);
    
    if (!isOpen) return null;
    
    const handleCategorySelect = (categoryId) => {
        selectCategory(categoryId);
    };
    
    const handleSearch = (e) => {
        searchTemplates(e.target.value);
    };
    
    const handleApplyTemplate = (template) => {
        applyTemplateToDocument(template);
    };
    
    const getCategoryCount = (categoryId) => {
        if (categoryId === 'all') return templates.length;
        return templates.filter(t => t.category === categoryId).length;
    };
    
    const getCategoryInfo = (categoryId) => {
        return categories.find(cat => cat.id === categoryId) || { color: '#95a5a6', icon: '📄' };
    };
    
    return (
        <div className="template-library-overlay">
            <div className="template-library-modal">
                {/* Header */}
                <div className="template-library-header">
                    <h2>📚 Template Kütüphanesi</h2>
                    <button 
                        className="close-button" 
                        onClick={closeTemplateLibrary}
                        title="Kapat"
                    >
                        ✕
                    </button>
                </div>
                
                {/* Search Bar */}
                <div className="template-search-bar">
                    <input
                        type="text"
                        placeholder="🔍 Template ara... (isim, açıklama, etiket)"
                        value={searchQuery}
                        onChange={handleSearch}
                        className="search-input"
                    />
                    {searchQuery && (
                        <button 
                            className="clear-search-btn"
                            onClick={clearSearch}
                        >
                            Temizle
                        </button>
                    )}
                </div>
                
                <div className="template-library-content">
                    {/* Sidebar - Categories */}
                    <div className="template-sidebar">
                        <h3>Kategoriler</h3>
                        
                        {categories.map(cat => (
                            <div
                                key={cat.id}
                                className={`category-item ${selectedCategory === cat.id ? 'active' : ''}`}
                                onClick={() => handleCategorySelect(cat.id)}
                                style={{ borderLeftColor: cat.color }}
                            >
                                <span className="category-icon">{cat.icon}</span>
                                <span className="category-name">{cat.name}</span>
                                <span className="category-count">
                                    {getCategoryCount(cat.id)}
                                </span>
                            </div>
                        ))}
                    </div>
                    
                    {/* Main Content - Templates */}
                    <div className="template-main">
                        <div className="template-toolbar">
                            <div className="template-info">
                                <span>{templates.length} template bulundu</span>
                            </div>
                            <div className="view-mode-buttons">
                                <button
                                    className={`view-mode-btn ${viewMode === 'grid' ? 'active' : ''}`}
                                    onClick={() => setViewMode('grid')}
                                >
                                    ⊞ Grid
                                </button>
                                <button
                                    className={`view-mode-btn ${viewMode === 'list' ? 'active' : ''}`}
                                    onClick={() => setViewMode('list')}
                                >
                                    ☰ Liste
                                </button>
                            </div>
                        </div>
                        
                        {templates.length === 0 ? (
                            <div className="template-empty">
                                <p>🔍 Template bulunamadı</p>
                                <button onClick={clearSearch}>Filtreleri Temizle</button>
                            </div>
                        ) : (
                            <div className={`template-grid ${viewMode}`}>
                                {templates.map(template => {
                                    const categoryInfo = getCategoryInfo(template.category);
                                    return (
                                    <div key={template.id} className="template-card">
                                        <div 
                                            className="template-thumbnail"
                                            style={{
                                                background: `linear-gradient(135deg, ${categoryInfo.color} 0%, ${categoryInfo.color}dd 100%)`,
                                                position: 'relative',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            {template.thumbnail && template.elements && template.elements.length > 0 ? (
                                                <img
                                                    src={template.thumbnail}
                                                    alt={template.name}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'contain',
                                                        objectPosition: 'center',
                                                        display: 'block',
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        backgroundColor: '#ffffff'
                                                    }}
                                                    onError={(e) => { e.target.style.display = 'none'; }}
                                                />
                                            ) : (
                                                <div className="thumbnail-content">
                                                    <span className="thumbnail-icon">{categoryInfo.icon}</span>
                                                    <span className="thumbnail-name">{template.name}</span>
                                                </div>
                                            )}
                                            {template.popular && (
                                                <span className="popular-badge">⭐ Popüler</span>
                                            )}
                                            {(!template.elements || template.elements.length === 0) && (
                                                <span className="coming-soon-badge">🚧 Hazırlanıyor</span>
                                            )}
                                        </div>
                                        <div className="template-card-content">
                                            <h4>{template.name}</h4>
                                            <p>{template.description}</p>
                                            <div className="template-tags">
                                                {template.tags && template.tags.slice(0, 3).map(tag => (
                                                    <span key={tag} className="tag">#{tag}</span>
                                                ))}
                                            </div>
                                            <div className="template-actions">
                                                <button 
                                                    className="btn-use"
                                                    onClick={() => handleApplyTemplate(template)}
                                                >
                                                    📥 Kullan
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    isOpen: state.templateLibrary.isLibraryOpen,
    categories: state.templateLibrary.categories,
    templates: getFilteredTemplates(state),
    selectedCategory: state.templateLibrary.selectedCategoryId,
    searchQuery: state.templateLibrary.searchQuery,
    viewMode: state.templateLibrary.viewMode
});

const mapDispatchToProps = {
    closeTemplateLibrary,
    selectCategory,
    searchTemplates,
    clearSearch,
    setViewMode,
    loadTemplates,  
    loadCategories,
    applyTemplateToDocument
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateLibrary);
